import { AppAlert } from '@/components/AppAlert';
import { Button } from '@/components/ui/button';

export interface LoadErrorProps {
  /** What couldn't load: "Couldn't load runs". */
  title: string;
  /** The API's message, shown under the title. */
  error?: string | null;
  /** Shows a Retry button. */
  onRetry?: () => void;
  /** Spinner on Retry while the retry runs. */
  retrying?: boolean;
  /** Tighter, for inside a card, dialog or list body. */
  compact?: boolean;
  className?: string;
}

/**
 * A load that failed, in place of the empty state or spinner it would otherwise leave, so
 * "nothing here" and "couldn't check" never look the same. Not dismissible: it goes when a
 * load succeeds. Imports only AppAlert and Button.
 */
export function LoadError({
  title,
  error,
  onRetry,
  retrying = false,
  compact = false,
  className,
}: LoadErrorProps) {
  return (
    <AppAlert
      tone="critical"
      title={title}
      compact={compact}
      className={className}
      action={
        onRetry ? (
          <Button
            type="button"
            variant="outline"
            size={compact ? 'xs' : 'sm'}
            loading={retrying}
            loadingText="Retrying…"
            onClick={onRetry}
          >
            Retry
          </Button>
        ) : undefined
      }
    >
      {error ? <p className="break-words">{error}</p> : null}
    </AppAlert>
  );
}
